var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.166672C2.03587 0.166672 1.59075 0.351046 1.26256 0.679235C0.934375 1.00742 0.75 1.45254 0.75 1.91667V10.0833C0.75 10.5475 0.934375 10.9926 1.26256 11.3208C1.59075 11.649 2.03587 11.8333 2.5 11.8333H6C6.46413 11.8333 6.90925 11.649 7.23744 11.3208C7.56563 10.9926 7.75 10.5475 7.75 10.0833V1.91667C7.75 1.45254 7.56563 1.00742 7.23744 0.679235C6.90925 0.351046 6.46413 0.166672 6 0.166672H2.5ZM8.50425 3.25426C8.61364 3.1449 8.76199 3.08346 8.91667 3.08346C9.07135 3.08346 9.21969 3.1449 9.32908 3.25426L11.6624 5.58759C11.7718 5.69698 11.8332 5.84533 11.8332 6.00001C11.8332 6.15468 11.7718 6.30303 11.6624 6.41242L9.32908 8.74576C9.21907 8.85201 9.07172 8.91081 8.91877 8.90948C8.76582 8.90815 8.61951 8.8468 8.51136 8.73865C8.4032 8.63049 8.34185 8.48419 8.34052 8.33124C8.33919 8.17829 8.39799 8.03094 8.50425 7.92092L9.84183 6.58334H4.83333C4.67862 6.58334 4.53025 6.52188 4.42085 6.41248C4.31146 6.30309 4.25 6.15472 4.25 6.00001C4.25 5.8453 4.31146 5.69692 4.42085 5.58753C4.53025 5.47813 4.67862 5.41667 4.83333 5.41667H9.84183L8.50425 4.07909C8.39489 3.9697 8.33346 3.82135 8.33346 3.66667C8.33346 3.51199 8.39489 3.36365 8.50425 3.25426Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.c2dcf957b205da3fbe7982379b52fe8f.svg";
export { ForwardRef as ReactComponent };